export default {
      id: "share-usage",
      viewBox: "0 0 448 512",
      url: __webpack_public_path__ + "img/svg-sprite.svg#share",
      toString: function () {
        return this.url;
      }
    }